import { Pipe, PipeTransform } from "@angular/core";
import { IPatient } from "@comunicare/comunicare-interfaces";
import { PatientService } from "../providers/patient.service";

@Pipe({ name: "getPatientFullName" })
export class GetPatientFullNamePipe implements PipeTransform {
  constructor(private patientService: PatientService) {}

  transform(patient: IPatient): string {
    return this.patientService.getFullname(patient);
  }
}
